<template>
    <div class="position-box">
        <div class="head">
            <img class="back" src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('c2c.cjdd')}}</div>
             <router-link to="/c2cOrder" tag="div"><img class="icon" src="@/assets/dingdan.png" alt=""></router-link>
        </div>
        <div class="cotainer">
          <div class="tips">{{$t('c2c.fkrxm')}}</div>
          <div class="input-box"><input class="input" type="text" v-model="truename" :placeholder="$t('c2c.ccsr')"></div>
          <div class="tips">{{$t('c2c.nssdgj')}}</div>
          <div class="input-box"><input class="input" type="text" v-model="country" :placeholder="$t('c2c.ccsr')"></div>
          <div class="tips">{{$t('c2c.mmbz')}}</div>
          <div class="input-box" @click="selectBzShow">
            <input class="input" type="text" v-model="currency" :placeholder="$t('c2c.qxz')">
            <img class="arrow" src="@/assets/more2.png" alt="">
          </div>
           <div class="tips">{{$t('c2c.fkyhmc')}}</div>
          <div class="input-box"><input class="input" type="text" v-model="bankname" :placeholder="$t('c2c.ccsr')"></div>
          <div class="tips">{{$t('c2c.fkfs')}}</div>
          <div class="input-box"><input class="input" type="text" v-model="paytype" :placeholder="$t('c2c.dianhui')"></div>
          <div class="tips">{{$t('c2c.fb')}}</div>
          <div class="input-box">
            <input class="input" type="text" v-model="fiatmoney" :placeholder="$t('c2c.ccsr')">
          </div>
          <div class="tips">{{$t('c2c.ckje')}}</div>
          <div class="input-box"><input class="input" v-model="number" type="text" :placeholder="$t('c2c.ccsr')"></div>
        </div>
        <div class="btn-sure" @click="sure">{{$t('xgdlmm.t7')}}</div>
        <div class="mask" v-show="isSelect" @click="hide"></div>
        <ul class="select-box select-box3" v-show="isSelect">
          <li class="select" v-for="(item,index) in currencyList" :key="index" @click.stop="select(item.name)">{{item.name | rewriteName}}</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'c2cCreate',
    data () {
        return {
          token: '',
          isSelect: false,
          country: '',
          truename: '',
          bankname: '',
          currency: '',
          paytype: this.$t('c2c.dianhui'),
          fiatmoney: '',
          number: '',
          currencyList: [],
          count: 1
        }
    },
    created(){
      this.token = localStorage.getItem('token') || '';
    },
    mounted() {
      this.getmarketList();
      this.getCurrencysFiat();
    },
    methods: {
      back(){
        this.$router.push('/c2c')
      },
      getmarketList(){
          let params = {
            type: 'ctoc'
          }
          this.$ajax.get('/web/getCurrencyAll',{params}).then((res) => {
            let resData = res.data.data;
            this.currencyList = resData;
          }).catch(function(err){
              console.log(err)
          })
      },
      getmarketList2(){
        let params = {
          id: 1,
          type: 1
        }
        this.$ajax.get('/web/getmarketList',{params}).then((res) => {
          let resData = res.data.data;
          this.currencyList = this.currencyList.concat(resData);
          this.getOrderList();//获取记录
        }).catch(function(err){
            console.log(err)
        })
      },
      selectBzShow(){
        this.isSelect = true
      },
      hide(){
        this.isSelect = false
      },
      select(text){
        if(text == 'CMGCA0'){
          text = 'XAU';
        }else if(text == 'CMSIA0'){
          text = 'XAG';
        }
        this.currency = text;
        this.isSelect = false;
      },
      getCurrencysFiat(){
        this.$ajax.get('/Web/currencysFiat',{}).then((res) => {
          let resData = res.data.data;
        }).catch(function(err){
            console.log(err)
        })
      },
      sure(){
        var regEmail = /^\S+[@]+\S/;
        if(this.truename == '' || this.truename == null){
          this.$toast.center(this.$t('c2c.qsrfkrxm'));
          return;
        }
        if(this.country == '' || this.country == null){
          this.$toast.center(this.$t('c2c.qsrnssdgj'));
          return;
        }
        if(this.currency == '' || this.currency == null){
          this.$toast.center(this.$t('c2c.qxzmmbz'));
          return;
        }
        if(this.bankname == '' || this.bankname == null){
          this.$toast.center(this.$t('c2c.qsrfkyhmc'));
          return;
        }
        if(this.paytype == '' || this.paytype == null){
          this.$toast.center(this.$t('c2c.qtxfkfs'));
          return;
        }
        if(this.fiatmoney == '' || this.fiatmoney == null){
          this.$toast.center(this.$t('c2c.qtxfb'));
          return;
        }
        let params = {
          country: this.country,
          truename: this.truename,
          bankname: this.bankname,
          currency: this.currency,
          paytype: this.paytype,
          fiatmoney: this.fiatmoney,
          number: this.number,
        }
        if(this.count == 1){
          this.count = 0;
        }else{
            return false;
        }
        this.$ajax.post('/Web/assetCtoc',params).then((res) => {
          let resData = res.data;
          if(resData.code == 0 || resData.code == 4 || resData.code == 7){
              this.$toast.center(this.$t('status.statusText')[2]);
              setTimeout(() => {
                this.count = 1;
                this.$router.push('/c2cOrder')
              }, 1000)
          }else{
            this.count = 1;
            this.$toast.center(resData.message);
            return;
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      formattedNumber(num){
        var str = String(num);
        if(str.indexOf(".") > -1 || str.indexOf(",") > -1){
          return parseFloat(num.replace(/,/g, ''));
        }else{
          return parseFloat(num)
        }
      },
       keyMoney(){
          this.number = this.number.replace(/[^\d.]/g, "");  //仅保留数字和"."
          this.number = this.number.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
          this.number = this.number.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
          this.number = this.number.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
          if (this.number.indexOf(".") < 0 && this.number != "") { //首位是0的话去掉
              this.number = parseFloat(this.number);
          }
      },
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
  .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.2rem;
        padding: 0 .3rem;
        color: #fff;
        line-height: 1.2rem;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .3rem;
        margin-top: -.3rem;
    }
    .head .icon{
      position: absolute;
      right: .24rem;
      top: 50%;
      width: .54rem;
      transform: translateY(-50%);
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
      position: absolute;
      top: 1.2rem;
      bottom: 3.4rem;
      width: 100%;
      background: transparent;
      overflow-y: scroll;
    }
    .tips{
      padding: .4rem .48rem .2rem;
      color: #fff;
      font-size: .45rem;
    }
    .input-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 .34rem;
      padding: 0 .54rem;
      height: 1.3rem;
      background: rgba(26,36,63,.4);
      border-radius: 0.15rem;
    }
    .input-box .input::placeholder{
      color: #666;
      font-size: .42rem;
    }
    .input-box .input{
      flex: 1;
      height: 1.3rem;
      color: #fff;
      font-size: .42rem;
      line-height: 1.3rem;
    }
    .input-box .arrow{
      width: .25rem;
    }
    .btn-sure{
      position: absolute;
      left: .48rem;
      right: .48rem;
      bottom: 0;
      height: 1.28rem;
      margin: 1.5rem .48rem .6rem;
      color: #fff;
      font-size: .56rem;
      line-height: 1.28rem;
      background-color: #0060ff;
      border-radius: 0.2rem;
      text-align: center;
    }
    .text{
      padding: .3rem .52rem .6rem;
      color: #d2d2d2;
      font-size: .44rem;
    }
    .select-box{
        position: fixed;
        left: -1px;
        right: 0;
        bottom: 0;
        z-index: 1000;
        height: auto;
        max-height: 10rem;
        background: #0E1530;
        overflow-y: scroll;
    }
    .select-box .select{
        padding: .4rem 0;
        color: #fff;
        font-size: .4rem;
        border-bottom: 1px solid #858585;
        text-align: center;
    }
    .select-box .select:last-child{
        border-bottom: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/c2cCreate.vue